module.exports = __webpack_public_path__ + "img/shibanov.02fb8bdf.png";